import React from 'react';
import CalendarBlankIcon from '@/components/icons/CalendarBlankIcon/CalendarBlankIcon';
import SignpostIcon from '@/components/icons/SignpostIcon/SignpostIcon';
import AirplaneIcon from '@/components/icons/AirplaneIcon/AirplaneIcon';
import CalendarXIcon from '@/components/icons/CalendarXIcon/CalendarXIcon';
import AirplaneTakeoffIcon from '@/components/icons/AirplaneTakeoffIcon/AirplaneTakeoffIcon';
import CoffeIcon from '@/components/icons/CoffeIcon/CoffeIcon';
import { ListItem, UnorderedList } from './TravelDetailList.styles';
import BarcodeIcon from '@/components/icons/BarcodeIcon/BarcodeIcon';
import BoatIcon from '@/components/icons/BoatIcon/BoatIcon';

export interface TravelDetailListProps {
  travel_type?: Pick<PacoteTravelType, 'title' | 'slug'>;
  travel_duration: string | null;
  travel_city: string | null;
  travel_flight: string | null;
  expired_at: string | null;
  travel_depart: string | null;
  travel_meal: string | null;
  reference?: number | null;
}

const TravelDetailList = ({
  travel_type,
  travel_duration,
  travel_flight,
  travel_city,
  travel_meal,
  expired_at,
  travel_depart,
  reference,
  ...props
}: TravelDetailListProps) => {
  return (
    <UnorderedList>
      <ListItem>
        <CalendarBlankIcon />
        <span>
          Duração: <strong>{travel_duration}</strong>
        </span>
      </ListItem>
      {(travel_city && (
        <ListItem>
          <SignpostIcon />
          <span>
            Destinos: <strong title={travel_city}>{travel_city}</strong>
          </span>
        </ListItem>
      )) ||
        null}
      <ListItem>
        <AirplaneIcon />
        <span>
          Passagem Aérea: <strong>{travel_flight}</strong>
        </span>
      </ListItem>
      <ListItem>
        <CalendarXIcon />
        <span>
          Validade: <strong>{expired_at || '--'}</strong>
        </span>
      </ListItem>
      <ListItem>
        {(travel_type?.slug === 'cruzeiros' && <BoatIcon />) || <AirplaneTakeoffIcon />}
        <span>
          Saídas: <strong>{travel_depart}</strong>
        </span>
      </ListItem>
      {(travel_meal && travel_meal?.length > 1 && (
        <ListItem>
          <CoffeIcon />
          <span>
            Plano de Refeição: <strong>{travel_meal}</strong>
          </span>
        </ListItem>
      )) ||
        null}

      {(reference && (
        <ListItem>
          <BarcodeIcon />
          <span>
            Número de Referência: <strong>{reference}</strong>
          </span>
        </ListItem>
      )) ||
        null}
    </UnorderedList>
  );
};

export default TravelDetailList;
